import type { ReferenceNode } from '@newStore/documentUI/documentUITypes';

const ReferenceRow: React.FC<{ contentNode: ReferenceNode }> = ({ contentNode }) => {
  const reference = contentNode.referenceNode;

  if (!reference && !contentNode.loading) {
    return <div>Deze node verwijst naar verwijderde data.</div>;
  }

  if (reference) {
    return (
      <div className={'referenced-item'} key={reference.href}>
        {reference.identifier && (
          <span style={{ minWidth: '60px', display: 'inline-block', color: reference.color }}>
            {reference.identifier}
          </span>
        )}
        <span dangerouslySetInnerHTML={{ __html: reference.title }} />
      </div>
    );
  }

  return <div className="shimmer" style={{ height: '20px' }} />;
};

export default ReferenceRow;
